import BackgroundEffect from '../components/BackgroundEffect';
const GDPRComplianceStatemet = () => {
    const styles = {
        container: {
            maxWidth: "950px",
            margin: "50px auto",
            padding: "50px",
            background: "linear-gradient(180deg, #ffffff 0%, #f5f8fa 100%)",
            borderRadius: "16px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            fontFamily: "'Segoe UI', Roboto, sans-serif",
            color: "#003e64",
            lineHeight: "1.8",
            transition: "all 0.3s ease-in-out",
        },
        title: {
            fontSize: "2.6rem",
            fontWeight: "700",
            marginBottom: "10px",
            textAlign: "center",
            color: "#003e64",
            letterSpacing: "0.5px",
        },
        subtitle: {
            textAlign: "center",
            marginBottom: "35px",
            color: "#374651",
            fontSize: "1rem",
            backgroundColor: "#fdf3eb",
            padding: "15px",
            borderRadius: "10px",
            border: "1px solid #e87115",
        },
        section: {
            marginBottom: "35px",
            paddingBottom: "25px",
            borderBottom: "1px solid #e1e5e9",
        },
        sectionTitle: {
            fontSize: "1.3rem",
            fontWeight: "700",
            marginBottom: "12px",
            color: "#e87115",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        list: {
            marginLeft: "25px",
            paddingLeft: "10px",
            listStyleType: "disc",
        },
        listItem: {
            marginBottom: "6px",
            fontSize: "1.2rem",
        },
        paragraph: {
            fontSize: "1.2rem",
            color: "#003e64",
            marginBottom: "12px",
        },
        footer: {
            borderTop: "2px solid #e87115",
            marginTop: "40px",
            paddingTop: "25px",
            fontSize: "0.95rem",
            textAlign: "center",
            color: "#003e64",
            fontWeight: "600",
            letterSpacing: "0.4px",
        },
        contact: {
            marginTop: "15px",
            lineHeight: "1.6",
        },
        link: {
            color: "#e87115",
            textDecoration: "none",
            fontWeight: "600",
        },
        linkHover: {
            textDecoration: "underline",
        },
    };

    return (
        <div style={styles.container}>
            <BackgroundEffect />
            <h1 style={styles.title}>GDPR Compliance Statement</h1>
            <p style={styles.subtitle}>
                <strong>Effective Date:</strong> 2nd September 2025 <br />
                <strong>Company:</strong> JSKM Technologies Private Limited <br />
                <strong>Website:</strong>{" "}
                <a
                    href="https://www.jskmtechnologies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    https://www.jskmtechnologies.com
                </a>
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                    contact@jskmtechnologies.com
                </a>
                <br />
                <strong>Phone:</strong> +91 96763 62000
            </p>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>GDPR Compliance Statement</h2>
                <p style={styles.paragraph}>
                    JSKM Technologies is committed to compliance with the <b>European Union’s General Data Protection Regulation (GDPR)</b> for users located in the EU.
                </p>
            </div>

            {/* Section 1 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>1. Data Controller</h2>
                <p style={styles.paragraph}>
                    <b>JSKM Technologies Private Limited</b> acts as the Data Controller for processing personal data of EU users.<br/>
                    <b>Contact Information:</b><br/>
                    📧 <b>Email:</b>{" "}
                    <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a>{" "}
                    <br />
                    📞 <b>Phone:</b> +91 96763 62000 <br />
                </p>
            </div>

            {/* Section 2 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>2. Legal Basis for Processing</h2>
                <p style={styles.paragraph}>We process personal data based on one or more of the following:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Consent of the data subject</li>
                    <li style={styles.listItem}>
                        Performance of a contract
                    </li>
                    <li style={styles.listItem}>Legal obligation compliance</li>
                    <li style={styles.listItem}>Legitimate business interests</li>
                </ul>
            </div>

            {/* Section 3 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>3. GDPR User Rights</h2>
                <p style={styles.paragraph}>EU users have the following rights under GDPR:</p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>
                        <strong>Access:</strong> Request a copy of personal data we hold.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Correction:</strong> Update or correct inaccurate data.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Deletion:</strong> Request deletion of personal data (“Right to be Forgotten”).
                    </li>
                    <li style={styles.listItem}>
                        <strong>Processing Restriction:</strong> Restrict processing of your data.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Data Portability:</strong> Obtain a copy of your data in a portable format.
                    </li>
                    <li style={styles.listItem}>
                        <strong>Withdraw Consent:</strong> Revoke consent at any time for specific processing.
                    </li>
                </ul>
                <p style={styles.paragraph}>
                    Requests can be sent to <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com.
                    </a>
                </p>
            </div>

            {/* Section 4 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>4. Data Security</h2>
                <p style={styles.paragraph}>
                    We implement strong technical and organizational measures to protect personal data, including:
                </p>
                <ul style={styles.list}>
                    <li style={styles.listItem}>Encryption of sensitive data</li>
                    <li style={styles.listItem}>Secure server storage and access control</li>
                    <li style={styles.listItem}>
                        Regular monitoring and security audits
                    </li>
                </ul>
            </div>

            {/* Section 5 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>5. Data Transfers</h2>
                <p style={styles.paragraph}>
                    Data may be transferred outside the EU (e.g., to India) for operational purposes.<br />
                    We ensure adequate safeguards are in place to maintain GDPR compliance.
                </p>
            </div>

            {/* Section 6 */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>6. Data Retention</h2>
                <p style={styles.paragraph}>
                    Personal data is retained only for as long as necessary to fulfill purposes outlined, comply with legal obligations, and maintain business operations.<br />
                    When no longer required, data is securely deleted or anonymized.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>7. Contact for Data Protection</h2>
                <p style={styles.paragraph}>For any questions, concerns, or GDPR-related requests:</p>
                <p style={styles.contact}>
                    <b>JSKM Technologies Private Limited</b> <br />
                    📧 <b>Email:</b>{" "}
                    <a href="mailto:contact@jskmtechnologies.com" style={styles.link}>
                        contact@jskmtechnologies.com
                    </a>{" "}
                    <br />
                    📞 <b>Phone:</b> +91 96763 62000 <br />
                    🌐 <b>Website:</b>{" "}
                    <a
                        href="https://www.jskmtechnologies.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        https://www.jskmtechnologies.com
                    </a>
                </p>
            </div>
        </div>
    );
};

export default GDPRComplianceStatemet;